import { render, staticRenderFns } from "./UserPointList.vue?vue&type=template&id=28ade6e0&scoped=true&"
import script from "./UserPointList.vue?vue&type=script&lang=js&"
export * from "./UserPointList.vue?vue&type=script&lang=js&"
import style0 from "./UserPointList.vue?vue&type=style&index=0&id=28ade6e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ade6e0",
  null
  
)

export default component.exports